import React from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import Skeleton from "@mui/material/Skeleton";

export default function HomeSnapshotLoader() {
  return (
    <Card
      variant="outlined"
      sx={{
        background: "linear-gradient(45deg, #fc00ff 10%, #4A00E0 60%)",
      }}
    >
      <React.Fragment>
        <CardContent>
          <Typography sx={{ fontSize: 25 }} gutterBottom>
            <Skeleton width="50%" sx={{ bgcolor: "white" }} />
          </Typography>
          <Typography variant="body2">
            <Skeleton sx={{ bgcolor: "white" }} />
          </Typography>
        </CardContent>
      </React.Fragment>
    </Card>
  );
}
